// extracted by mini-css-extract-plugin
module.exports = {"SalesForceAccount":"SalesForceAccount_SalesForceAccount__2jwp6"};